import React, {useRef, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {IconButton} from '@components/common/base/buttons'
import {isAdmin} from '@components/dashboard/dashboard-utils'
import {keyboardHandler, useClickAway, useSyncEvent} from '@containers/hooks'
import {Company} from '@extensions/company'

const TwCompanyName = tw.div`
  mr-6

  before:content-['“']
  after:content-['”']
  whitespace-nowrap

  h1-semibold
`

const TwInput = tw.input`
 all-unset
 h1-semibold
 text-primary
 h-16
 pb-4
 -mb-4
 shadow-border-b-1
 shadow-grey-l60
`

export const EditableCompanyName = () => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [editing, setEditing] = useState(false)
  const [company, setCompany] = useState(Company.getCurrent)
  const [name, setName] = useState(company?.name ?? '')

  const update = () => {
    const company = Company.getCurrent()
    setCompany(company)
    setName(company.name)
  }
  useSyncEvent('profile', {debounceTime: 50, filter: '*'}, update)

  const save = () => {
    if (name.trim()) {
      const box = Sync.getCurrentSandbox()
      const c = box.get(box.companyId) as Hub
      box.editTitle(c, name.trim().slice(0, 24))
    }
    cancel()
  }
  const cancel = () => {
    setEditing(false)
    update()
    return true
  }
  useClickAway(inputRef, save)

  return (
    <div
      className="flex items-center cursor-pointer"
      onClick={() => isAdmin() && !editing && setEditing(true)}
    >
      <div className="h1-semibold mr-6">{Lang.msg.common.company}</div>
      {editing ? (
        <TwInput
          ref={inputRef}
          autoFocus
          onFocus={e =>
            e.target.setSelectionRange(
              e.target.value.length,
              e.target.value.length
            )
          }
          onBlur={save}
          onKeyDown={keyboardHandler({
            enter: save,
            escape: cancel
          })}
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder={Lang.msg.companyPlaceholder}
        />
      ) : (
        <>
          <TwCompanyName>{company.name}</TwCompanyName>
          {isAdmin() && (
            <IconButton
              icon="IconEdit"
              color="grey"
              size="small"
              onClick={() => setEditing(true)}
              className="-mx-4 !w-24 !h-28"
            />
          )}
        </>
      )}
    </div>
  )
}
